import { useEffect, useState } from "react";
import data from "../json/data.json";
import { useAssessment } from "../components/assessmentContext";
import { GetDashboardDetails } from "../apis/services/csaApi";
import { useNavigate } from "react-router-dom";
import  en  from "../json/en.json";
import  ch  from "../json/ch.json";
export default function LandingPage() {
   const lId =
    localStorage.getItem("languageId") || "1";

  const { activeAssessment } = useAssessment();
  const [calendarData, setCalendarData] = useState([]);
   
  const assessment =
    localStorage.getItem("AssessmentText") || "Self Assessment";
  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getDashboardDetails = () => {
    GetDashboardDetails("CalData",localStorage.getItem("userName"), localStorage.getItem("AssessmentId")).then((response) => {
      console.log("GetDashboardDetails", response);
      if (response && response.length > 0) {
        setCalendarData(response);
      }
    });
  };

  const renderCard = (item, title) => {
    if (!item) return null;

    return (
      <div className="calendar-card">
        <div className="calendar-card__top">
          <h2>{title}</h2>
        </div>
        <div className="calendar-card__body">
          <div className="left-section">
            <div className="start-date">
              <h2>{lId==="1"?en.startDate:ch.startDate}</h2>
              <div className="date">
                <span className="month">{item.startMonth || "--"}</span>
                <span className="day">{item.startDate || "--"}</span>
                <span className="year">{item.startDay || "--"}</span>
              </div>
              <div className="score">
                <h2 style={{ color: "#3a3a3c" }}>
                  {lId==="1"?en.currentScore:ch.currentScore}
                  </h2>
                <p style={{ color: "#3a3a3c" }}>
                  {item.currentScore || "00"}
                  </p>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="end-date">
              <h2>{lId==="1"?en.endDate:ch.endDate}</h2>
              <div className="date">
                <span className="month">{item.endMonth || "--"}</span>
                <span className="day">{item.endDate || "--"}</span>
                <span className="year">{item.endDay || "--"}</span>
              </div>
              <div className="score">
                <h2 style={{ color: "#3a3a3c" }}>
                  {lId==="1"?en.desiredScore:ch.desiredScore}
                  </h2>
                <p style={{ color: "#3a3a3c" }}>
                  {item.desiredScore || "00"}
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const navigate = useNavigate();

  const handleBoxClick = (boxNumber) => {
    console.log(boxNumber);
    navigate("/questionnaires", {
      state: {
        // activeTabHome: boxNumber,
        activeTab: boxNumber+1,
      },
    });
  };

  return (
    <div className="wrapper">
      <div className="section-score">
        <h1 className="main-heading">{lId==="1"?en.calTitle:ch.calTitle}</h1>
        <div className="calender-container">
          {renderCard(calendarData[0]?.[0], lId==="1"?en.selfAssessment:ch.selfAssessment)}
          {renderCard(calendarData[1]?.[0], lId==="1"?en.reviewAssessment:ch.reviewAssessment)}
          {renderCard(calendarData[2]?.[0], lId==="1"?en.finalEvaluation:ch.finalEvaluation)}
        </div>
      </div>

      <div className="section-process">
        <h2 className="secondary-heading">
          {lId==="1"?en.conduct:ch.conduct} {assessment} ({lId==="1"?en.clickTheProcessBelow:ch.clickTheProcessBelow})
        </h2>
        <div className="calender-container">
          <div className="landing-wrapper">
            <div className="landing-bg">
              <img src="/assets/landingPage/landingBG.png" alt="" />
            </div>
            <div className="landing-bg-overlap">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className={`box box-${index}`}
                  onClick={() => handleBoxClick(index)}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
